import {ClientDomain} from "@client/contracts";
import {client, ClientFetchProtocol} from "@typesec/mrpc";

export const rpc = client(ClientDomain, new ClientFetchProtocol("/api/client"));
